/**
 * Map names for mutations
 * @types {string}
 */

export const SET_CHECKLISTS = "COMPONENT/SET_CHECKLISTS";
export const SET_SHOW_LATTER_CHECKLIST = "COMPONENT/SET_SHOW_LATTER_CHECKLIST";

export const ADD_ROUTE_TO_BREADCRUMBS = "COMPONENT/ADD_ROUTE_TO_BREADCRUMBS";
export const REMOVE_ROUTE_FROM_BREADCRUMBS = "COMPONENT/REMOVE_ROUTE_FROM_BREADCRUMBS";
export const FORCE_REMOUNT_COMPONENT = "COMPONENT/FORCE_REMOUNT_COMPONENT";

export const RESET_ALL_BREADCRUMBS = "COMPONENT/RESET_ALL_BREADCRUMBS";




